<template>
    <el-row style="text-align: left;margin: 10px 60px">
        <!-- 产品开发管理 -->

        <!-- 开发文档列表 -->
        <pro-req-table></pro-req-table>

        <el-alert
                style="margin: 8px 0"
                title="这里没有提供删除开发需求的功能，你可以在状态变更中使用'废弃'代替此功能！"
                type="info"
                :closable="false"
                show-icon>
        </el-alert>

        <!-- 新增文档列表 -->
        <create-new-pro-req></create-new-pro-req>


    </el-row>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CreateNewProReq from "./ProReqChildren/CreateNewProReq"
    import ProReqTable from "./ProReqChildren/ProReqTable"

    export default {
        name: "ProRequirement",
        components: {ProReqTable, CreateNewProReq},
        computed: {
            proRequirements() {
                return this.ProRequirementData['proRequirements']
            },

            ...mapGetters(['ProRequirementData'])
        },

    }
</script>

<style scoped>

</style>